export default function lazyRetry(importFn) {
  return new Promise((resolve, reject) => {
    const hasRefreshed = sessionStorage.getItem("chunk_reload");

    importFn()
      .then((module) => {
        sessionStorage.removeItem("chunk_reload");
        resolve(module);
      })
      .catch((error) => {
        const isChunkError =
          error?.name === "ChunkLoadError" ||
          /Loading chunk [\d]+ failed/i.test(error?.message || "");

        if (isChunkError && !hasRefreshed) {
          sessionStorage.setItem("chunk_reload", "true");
          window.location.reload();
          return;
        }

        reject(error);
      });
  });
}